import * as React from 'react';
import { SnackbarContent } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { withStyles, IconButton, Snackbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

export interface OwnProps {
    isSuccess: boolean;
    message: string;
    classes: any;
}

const styles = {
    snackbar: {
        backgroundColor: green[600],
        color: 'white'
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: 10,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
}

class SuccessSnackBarComponent extends React.Component<OwnProps> {
    public state = {
        isSuccess: false,
    }

    public UNSAFE_componentWillReceiveProps(newProps: OwnProps) {
        if(this.props.isSuccess !== newProps.isSuccess || this.props.message !== newProps.message){
          this.setState({
            isSuccess: newProps.isSuccess,
        });
        }
    }

    public render() {
        const { classes } = this.props;
        return (
          <div>
              <Snackbar
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                open={this.state.isSuccess}
                autoHideDuration={4000}
                onClose={this.handleClose}
              >
                <SnackbarContent
                className={classes.snackbar}
                aria-describedby='client-snackbar'
                message={
                  <span id='client-snackbar' className={classes.message}>
                    <CheckCircleIcon className={`${classes.icon} ${classes.iconVariant}`} />
                    {this.props.message.split(':')[0]}
                  </span>
                }
                action={[
                  <IconButton key='close' aria-label='Close' color='inherit' onClick={this.handleClose}>
                    <CloseIcon className={classes.icon} />
                  </IconButton>,
                ]}
              />
              </Snackbar>
              </div>);
    }


  private handleClose = () => {
    this.setState({ isSuccess: false});
  }
}

export default withStyles(styles)(SuccessSnackBarComponent);
